import chalk from 'chalk';
const logFn = console.log;

const log = (title, ...infos) => {
  if (infos.length === 0) {
    return logFn(`${new Date().toISOString()} `, title);
  }

  return logFn(`${new Date().toISOString()} [${title}] `, ...infos);
};

const logErr = (title, ...infos) => {
  if (infos.length === 0) {
    return logFn(chalk.red(`${new Date().toISOString()} `, title));
  }

  return logFn(chalk.red(`${new Date().toISOString()} [${title}] `, ...infos));
};

export {
  log,
  logErr,
  log as info,
  logErr as error,
};
